import React from 'react';
import './Home.css';

// Import required components and constants
import { Button, CountdownTimer } from '../../../components';
import { home } from '../../../constants';



const Home = () => {

  return (
    <section className='home'>

      {/* Background image */}
      <img src={home.image} alt="Home-Pic" />

      {/* Content overlay */}
      <div className="content">
        <div className="text">

          <h5>{home.subtitle}</h5> {/* Subtitle text */}

          {/* Main title with optional highlighted span inside curly braces */}
          <h1>
            {
              home.title.includes('{') ? (
                <>
                  {home.title.split('{')[0]}               {/* Text before the span */}
                  <span>{home.title.split('{')[1].split('}')[0]}</span> {/* Highlighted text */}
                  {home.title.split('}')[1]}               {/* Text after the span */}
                </>
              ) : home.title                              // Plain title if no special format
            }
          </h1>

          <div className='btn-container'>
            <Button link={home.buttonLink} title={home.buttonText} /> {/* Call to Action button */}
          </div>

          <CountdownTimer targetDate={new Date("2025-12-31T00:00:00")} /> {/* Countdown Timer component with a target date */}

        </div>
      </div>

    </section>
  );
};

export default Home;